import { useState, useEffect } from 'react';
import {
  webDocs,
  iosDocs,
  androidDocs,
  restDocs,
  unityDocs,
  gettingStartedMenu,
  edgeauthDocs,
  portalDocs,
  // KB Menus
  howToMenu,
  referenceMenu,
  faqMenu,
  troubleshootMenu,
  reactNativeDocs,
} from '../../menus';

interface WindowState {
  /** Width of the window */
  width?: number;
  /** Height of the window */
  height?: number;
}

/**
 * A React hook that adds a resize event-listener to the window and returns
 * the current window size
 */
export function useWindowSize() {
  const [windowSize, setWindowSize] = useState<WindowState>({});

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

export function getTitle(path: string) {
  return path.includes('/getting-started/')
    ? 'Getting Started'
    : path.includes('/faqs/')
    ? 'FAQs'
    : path.includes('/how-to/')
    ? 'How-To Guides'
    : path.includes('/troubleshooting/')
    ? 'Troubleshooting'
    : undefined;
}

/**
 * A helper function that uses the current path to determine which docs menu
 * to render in the side navigation bar
 */
export function getSideMenu(path: string) {
  const menu = path.includes('/web/')
    ? webDocs
    : path.includes('/rest-api/')
    ? restDocs
    : path.includes('/ios/')
    ? iosDocs
    : path.includes('/android/')
    ? androidDocs
    : path.includes('/getting-started/')
    ? gettingStartedMenu
    : path.includes('/unity/')
    ? unityDocs
    : path.includes('/react-native/')
    ? reactNativeDocs
    : path.includes('/edgeauth/')
    ? edgeauthDocs
    : path.includes('/portal')
    ? portalDocs
    : path.includes('/knowledge-base/how-to')
    ? howToMenu
    : path.includes('/knowledge-base/troubleshooting')
    ? troubleshootMenu
    : path.includes('/knowledge-base/faqs')
    ? faqMenu
    : path.includes('/knowledge-base/reference')
    ? referenceMenu
    : [];

  return menu.map(({ path, submenu, ...rest }) => ({
    path,
    submenu: submenu?.map(({ label, path: submenuPath, submenu: _submenu }) => {
      return { label, path: submenuPath, submenu: _submenu };
    }),
    ...rest,
  }));
}

/**
 * Returns a formatted selector string for `id` or `className` attributes that
 * merges user generated classNames with component defaults.
 *
 * @param selectors - an array of classNames or ids supplied by component props.
 * Can be dynamically generated
 *
 */
export function mergeSelectors(
  selectors: (string | undefined)[]
): string | undefined {
  let s = selectors
    ? selectors
        .join(' ')
        .replace(/ +(?= )/g, '')
        .trim()
    : undefined;

  return s === '' ? undefined : s;
}
